import { ScrollingColumn } from 'foundations-components/transitional/components/ScrollingColumn';
import { useIsUngatedForAiSearch, useIsUngatedForReadabilityMetrics, useSelectHasScope } from '../context/XrayPanelContext';
import { TopicsGroupWrapper } from '../seo/topicsGroup/components/TopicsGroupWrapper';
import { ReadabilitySection } from '../seo/readability/components/ReadabilitySection';
import { AiSearchGroupWrapper } from '../seo/recommendations/aiSearchEngineOptimization/AiSearchGroupWrapper';
import { CompletionStatuses } from '../constants';
import { getGroupIncompleteCount } from '../utils/auditResultsUtils';
import { GroupView } from '../seo/sharedComponents/GroupView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SectionView = ({
  auditResults,
  config,
  artifacts,
  contentId,
  withReadabilitySection
}) => {
  const {
    recommendations
  } = config;
  const hasTopicClustersAccess = useSelectHasScope('topic-clusters-access');
  const hasReadabilityMetricsAccess = useIsUngatedForReadabilityMetrics();
  const showReadabilitySection = hasReadabilityMetricsAccess && withReadabilitySection;

  // AI Search uses dynamic CHIRP data, so it's rendered separately via AiSearchGroupWrapper
  const isUngatedForAiSearch = useIsUngatedForAiSearch();
  const groupedRecommendations = recommendations.reduce((groupedRecs, rec) => {
    const groupType = rec.groupBy;
    const recs = groupedRecs[groupType] || [];
    if (rec.view) {
      recs.push(rec);
    }
    return Object.assign({}, groupedRecs, {
      [groupType]: recs
    });
  }, {});
  return /*#__PURE__*/_jsxs(ScrollingColumn, {
    children: [showReadabilitySection && /*#__PURE__*/_jsx(ReadabilitySection, {
      artifacts: artifacts
    }), hasTopicClustersAccess && /*#__PURE__*/_jsx(TopicsGroupWrapper, {
      contentId: contentId,
      artifacts: artifacts
    }), isUngatedForAiSearch && /*#__PURE__*/_jsx(AiSearchGroupWrapper, {
      contentId: contentId
    }), Object.entries(groupedRecommendations).map(group => {
      const [groupType, groupRecs] = group;
      const incompleteCount = getGroupIncompleteCount({
        auditResults,
        groupRecs
      });
      const recViews = [];
      for (const rec of groupRecs) {
        if (rec.view) {
          const RecommendationViewComponent = rec.view;
          const recAuditResult = auditResults[rec.type];
          if (recAuditResult && recAuditResult.status !== CompletionStatuses.NOT_APPLICABLE) {
            recViews.push( /*#__PURE__*/_jsx(RecommendationViewComponent
            // @ts-expect-error TS can't identify if this rec has a valid view component
            , {
              // @ts-expect-error TS can't identify which audit result shape should be applied to this rec
              auditResult: recAuditResult
              // @ts-expect-error TS can't identify which editorApi should be applied to this rec
              ,
              editorApi: config.editorApi
              // @ts-expect-error TS can't identify which contentId should be applied to this rec
              ,
              contentId: contentId
            }, rec.type));
          }
        }
      }
      if (recViews.length === 0) {
        return null;
      }
      return /*#__PURE__*/_jsx(GroupView, {
        groupType: groupType,
        incompleteCount: incompleteCount,
        children: recViews
      }, groupType);
    })]
  });
};